export const navLinks = [
  { name: 'Home', link: '/' },
  { name: 'About', link: '#about' },
  { name: 'MegaEvents', link: '#events' },
  { name: 'Management', link: '#management' },
  { name: 'Contact Us', link: '#contact' },
];
